import { LoadingOverlay, Paper, SimpleGrid, Space, Container, Stack, Image, Text, Button, Group } from '@mantine/core';
import React, { memo, useContext, useEffect, useState } from 'react';
import LcaReportComponent from './LCAReport/LcaReport.component';
import { baseUrl } from '../../Constants/constant';
import useFetch from '../../Customhooks/useFetch';
import DraftComponent from '../ComputeLca/DraftList.component.tsx/Draft.component';
import { authContext } from '../../context/AuthProvider.component';
import { IoAdd, IoCloudUpload } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
    const token = localStorage.getItem("token");
    const { setError }: any = useContext(authContext);
    const [reports, setReports] = useState<any>([]);

    const navigate = useNavigate();

    const { data: datalist, loading: listLoading, error: listError, fetchData: gettable } = useFetch({
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            token,
        },
    });

    useEffect(() => {
        gettable(`${baseUrl}compute/lca/calculateLca?page=1&limit=5`);
    }, []);

    useEffect(() => {
        if (datalist?.data) {
            setReports(datalist?.data?.data.slice(0, 2));
        }
    }, [datalist]);
    useEffect(() => {
        if (listError) {
            setError(listError?.message)
        }
    }, [listError])

    return (
        <>
            <LoadingOverlay
                visible={listLoading}
                zIndex={1000}
                overlayProps={{
                    radius: 'sm',
                    blur: 2,
                    style: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    }
                }}
                loaderProps={{ color: '#404040', type: 'bars' }}
            />
            {datalist?.data?.data?.length > 0 && (<>
                <SimpleGrid cols={{ base: 1, sm: 1, lg: 2 }}>
                    {reports?.map((report: any, index: number) => (
                        <Paper key={index} shadow='lg' p='sm' w='100%'>
                            <LcaReportComponent value={report} />
                            <Space h="xl" />
                            <Space h="xl" />
                        </Paper>
                    ))}
                </SimpleGrid>
                <Paper shadow='lg' p='sm' w='100%'>
                    <DraftComponent />
                </Paper>
            </>)}
            {datalist?.data?.data?.length == 0 &&
                <>
                    <Container size="md" style={{ minHeight: '70vh' }}>
                        <Stack
                            align="center"
                            justify="center"
                            gap="xl"
                            style={{ minHeight: '70vh' }}
                        >
                            <Image
                                src="4936930.jpg"
                                alt="Empty dashboard"
                                width={200}
                                height={200}
                                fit="contain"
                            />

                            <Stack align="center" gap="sm">
                                <Text size="xl" fw={600} c="dimmed">
                                    No data to display
                                </Text>
                                <Text size="sm" c="dimmed" ta="center" maw={400}>
                                    Start adding reports to build your dashboard
                                </Text>
                            </Stack>

                            <Group>
                                <Button color='#404040' leftSection={<IoAdd size={16} />} onClick={() => navigate('/newlca')}>
                                    Add Reports
                                </Button>
                            </Group>
                        </Stack>
                    </Container>
                </>
            }
        </>
    );
};

export default memo(Dashboard);